import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

// Mock data for the overview chart
const data = [
  {
    name: "Ene",
    ingresos: 5000000,
    gastos: 3200000,
  },
  {
    name: "Feb",
    ingresos: 4200000,
    gastos: 2800000,
  },
  {
    name: "Mar",
    ingresos: 7500000,
    gastos: 4100000,
  },
  {
    name: "Abr",
    ingresos: 6200000,
    gastos: 3900000,
  },
  {
    name: "May",
    ingresos: 9100000,
    gastos: 5300000,
  },
  {
    name: "Jun",
    ingresos: 10200000,
    gastos: 6100000,
  },
  {
    name: "Jul",
    ingresos: 8400000,
    gastos: 4800000,
  },
];

// Custom formatter for numbers in the tooltip
const formatNumber = (value: number) => `$${value.toLocaleString("es-CL")}`;

export function Overview() {
  return (
    <ResponsiveContainer width="100%" height={350}>
      <BarChart data={data}>
        <XAxis
          dataKey="name"
          stroke="#888888"
          fontSize={12}
          tickLine={false}
          axisLine={false}
        />
        <YAxis
          stroke="#888888"
          fontSize={12}
          tickLine={false}
          axisLine={false}
          tickFormatter={(value) => `$${(value / 1000000).toFixed(1)}M`}
        />
        <Tooltip
          formatter={formatNumber}
          labelFormatter={(label) => `Mes: ${label}`}
        />
        <Bar
          dataKey="ingresos"
          fill="#4ADE80"
          radius={[4, 4, 0, 0]}
          name="Ingresos"
        />
        <Bar
          dataKey="gastos"
          fill="#F43F5E"
          radius={[4, 4, 0, 0]}
          name="Gastos"
        />
      </BarChart>
    </ResponsiveContainer>
  );
}
